import { type ChartData } from './chartConfigUtils';
import CurrencyValueChart from './CurrencyValueChart';

interface TotalInterestPaidChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function TotalInterestPaidChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: TotalInterestPaidChartProps): JSX.Element {
    return (
        <CurrencyValueChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            currency={currency}
            config={{
                chartType: 'column',
                yAxisTitleKeyEur: 'statistics.charts.totalInterestPaidEur',
                yAxisTitleKeyLei: 'statistics.charts.totalInterestPaidLei',
                yAxisTitleFallbackEur: 'Total Interest Paid (EUR)',
                yAxisTitleFallbackLei: 'Total Interest Paid (Lei)',
                color: '#13c2c2',
                seriesNameKey: 'statistics.charts.totalInterestPaid',
                seriesNameFallback: 'Total Interest Paid',
            }}
        />
    );
}

export default TotalInterestPaidChart;
